import { useSelector } from "react-redux";
import { AppState } from "../redux/store";
import { clearSocketData } from "../redux/socket-data-slice";
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";

/**
 * Exposes socket data for a given event along with helpers for clearing it.
 * @param eventName - Socket event key to monitor within the store.
 * @returns Tuple of all data, the most recent item, and a clear function.
 */
export function useSocketData<T>(eventName: string) {

    const dispatch = useDispatch();
    const _eventData = useSelector<AppState>(state => state.socketData[eventName]) as T[] | undefined;
    const [_lastItem, setLastItem] = useState<T | undefined>(undefined);
    const [_data, setData] = useState<T[]>([]);
   
    useEffect(() => {
        if (_eventData && _eventData.length > 0) {
            setLastItem(_eventData[_eventData.length - 1]);
            setData(_eventData);
        } else {
            setLastItem(undefined);
            setData([]);
        }
    }, [_eventData]);


    /**
     * Removes processed socket items from the store for this event.
     * @param ids - Identifiers of items to clear.
     */
    const clear = useCallback((ids: string[]) => {
        
        dispatch(clearSocketData({ eventName: eventName, items: ids }))

    }, [dispatch, eventName])



    // const data = _state[eventName] as T[];
    // let lastItem: T | undefined = undefined;
    // if (data) {
    //     lastItem = data[data.length - 1]
    // }

    return [_data, _lastItem, clear] as const;
}

